// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"44caddbb","205":"beb8d0fb","551":"f1f90a01","643":"2d37786f"}[chunkId] + ".chunk.js";
};